<div class="field boolean">
    <mat-form-field>
        <mat-select [formControl]="control">
            <mat-option [value]="true"> Enabled/Enforced</mat-option>
            <mat-option [value]="false">Disabled</mat-option>
            <mat-option [value]="'any'">Ignore</mat-option>
        </mat-select>
    </mat-form-field>
</div>
